module.exports = __webpack_public_path__ + "static/app-118f17ef16aff8f787f4dcd69ef763f7.png";